import { z } from 'zod/v4';

export const auditLogSchema = z.object({
  accountId: z.nullable(z.number()),
  partnerId: z.nullable(z.string()),
  email: z.nullable(z.string()),
  operation: z.nullable(z.string()),
  userId: z.nullable(z.number()),
  requestOrigin: z.nullable(z.string()),
  responseBody: z.nullable(z.string()),
  requestBody: z.nullable(z.string()),
  requestTimestamp: z.nullable(z.string()),
  requestEndPoint: z.optional(z.string()),
  responseLength: z.optional(z.number()),
  offset: z.array(z.union([z.string(), z.number()])),
});

export type AuditLog = z.infer<typeof auditLogSchema>;
